import gql from "graphql-tag";

export const deleteArticleMutation = gql`
  mutation deleteArticle($id: ID!) {
    deleteArticle(id: $id) {
      id
    }
  }
`;
